const ENABLED_VALUES = new Set(['1', 'true', 'yes', 'on'])

export type MaintenanceLocale = 'en' | 'pt' | 'es'

export const SUPPORTED_MAINTENANCE_LOCALES: MaintenanceLocale[] = ['en', 'pt', 'es']

export function isMaintenanceModeEnabled() {
  return ENABLED_VALUES.has((import.meta.env.VITE_MAINTENANCE_MODE || '').trim().toLowerCase())
}

export function normalizeMaintenanceLocale(value?: string | null): MaintenanceLocale | null {
  const normalized = value?.trim().toLowerCase()

  if (!normalized) return null
  if (normalized.startsWith('pt')) return 'pt'
  if (normalized.startsWith('es')) return 'es'
  if (normalized.startsWith('en')) return 'en'
  if (SUPPORTED_MAINTENANCE_LOCALES.includes(normalized as MaintenanceLocale)) {
    return normalized as MaintenanceLocale
  }

  return null
}

export function getPreferredMaintenanceLocale(): MaintenanceLocale {
  if (typeof window === 'undefined') return 'en'

  const queryLocale = normalizeMaintenanceLocale(new URLSearchParams(window.location.search).get('lang'))
  if (queryLocale) return queryLocale

  const storedLocale = normalizeMaintenanceLocale(window.localStorage.getItem('i18nextLng'))
  if (storedLocale) return storedLocale

  return normalizeMaintenanceLocale(window.navigator.language) || 'en'
}
